export default {
  users: '/api/users', // 用户信息
  customers: '/api/customers', // 客户信息
  custCity: '/api/customers/city', //获取客户的城市
  custUser: '/api/customers/', //获取客户的城市
  scheduele: '/api/schedue', // 发起规划请求
  dayinfo: '/api/schedue/dayinfo', // 当天拜访数据
  putDayinfo: '/api/schedue/dayinfo', // 更改拜访计划
  schedueUsers: '/api/schedue/users', // 获取有权限规划的用户
  allDates: '/api/schedue/all_dates', // 初始化加载全部数据
  allNormalData: '/api/normal_data', // 获取历史数据
  customersSearch: '/api/customers/search', // 客户页搜索
  usersSearch: '/api/users/search', // 成员页搜索
  // createDateOption: '/api/schedue/option', // 获取创建日程详情
  createDateOption: '', // 获取创建日程详情
  createDate: '/api/schedue', // 创建日程,
  planStatus: '/api/planStatus', // 获取规划状态
  login: '/api/login', // 获取登录信息
  markers: '/api/customers/sort', //切换人员
  district: '/api/district', // 获取城市
  downloadMemberStatistics: '/api/customers/count_customer', //下载人员统计信息
  districtCount: '/api/customers/district_count', //获取行政区划内新老用户个数
  downloadRegionStatistics: 'api/customers/count_district', //下载行政区划统计信息
  down_plandata: '/api/down_plandata', // 导出规划数据
  down_normaldata: '/api/down_normaldata', // 导出实际数据
  manualPlan: '/api/manualPlan', // 手动开始刚才规划的数据
  update: '/api/uploadData', // 手动开始刚才规划的数据
  down_monthNormaldata: '/api/down_monthNormaldata',
  down_monthPlandata: '/lhlhData/',
  softium0: '/api/softium0',
  softium1: '/api/softium1',
  softium2: '/api/softium2',
  softFileNames: '/api/softium3/filenames',
  softFileData: '/api/softium3/fileData',
  planDemoData: '/api/demo/planData',
  planDemoRegions: '/api/demo/regions',
  bimboFileData: '/api/bimboFileData/fileData',
  getFileData: '/api/file',
  demoLogin: '/api/demo/login',
  setOption: '/api/demo/setOption',
  getOption: '/api/demo/getOption',
  getResStatus: '/api/demo/getResStatus',
  getUserPoint: '/api/userPoint',
  applyTrial: 'https://zk.changjing.com.cn/api/apply' // 申请试用
};



// WEBPACK FOOTER //
// ./src/service/api.js